import React from "react";

interface TicketConfirmationData {
  firstName: string;
  lastName: string;
  email: string;
  subject: string;
  category: string;
  description: string;
}

const TicketConfirmation: React.FC<{
  data: TicketConfirmationData;
}> = ({ data }) => {
  const rows: { label: string; value: string }[] = [
    { label: "First Name", value: data.firstName },
    { label: "Last Name", value: data.lastName },
    { label: "Email", value: data.email },
    { label: "Category", value: data.category },
    { label: "Subject", value: data.subject },
    { label: "Description", value: data.description },
  ];

  return (
    <div>
      <p style={{ marginBottom: 10 }}>
        ⚠️ Please confirm the support ticket details before creation:
      </p>
      {rows.map(({ label, value }) => (
        <p key={label} style={{ margin: "4px 0" }}>
          <strong>{label}:</strong> {value || "—"}
        </p>
      ))}
      <p style={{ marginTop: 10 }}>
        Reply with <strong>&apos;Confirm&apos;</strong> to create the ticket or
        provide corrections.
      </p>
    </div>
  );
};

export default TicketConfirmation;
